module.exports = __webpack_public_path__ + "img/21.3321bf0b.png";